import  {KeyWordSearchService}  from "./KeyWordSearchService";

/// <summary>
/// 根据关键字搜索公交规划建议词
/// </summary>
export class  BusPlanSuggestKeyWordSearchService  extends KeyWordSearchService{

    constructor()
	{
        super();
		
    }
    
    
}//end BusPlanSuggestKeyWordSearchService

